var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuOrgan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .MenuOrgan_a {\n                fill: #ff0d0d;\n                opacity: 0;\n            }\n\n            .MenuOrgan_b {\n            }\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-23 -403)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "MenuOrgan_a",
    width: 24,
    height: 24,
    transform: "translate(23 403)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "MenuOrgan_b",
    d: "M469.053,747.949h-3.284l-.063-4.579a.947.947,0,0,0-.947-.948h-5.811v-3.631h3.347a.947.947,0,0,0,.947-.947v-5.526a.947.947,0,0,0-.947-.947h-8.589a.947.947,0,0,0-.947.947v5.526a.947.947,0,0,0,.947.947h3.347v3.631h-5.81a.947.947,0,0,0-.947.948v4.579h-3.348a.947.947,0,0,0-.947.947v5.526a.947.947,0,0,0,.947.947h8.589a.947.947,0,0,0,.884-.947V748.9a.947.947,0,0,0-.884-.945v0h-3.347v-3.632h11.684v3.632h-3.411a.947.947,0,0,0-.947.947h.063v5.526a.947.947,0,0,0,.884.945v0h8.589a.947.947,0,0,0,.947-.947V748.9A.947.947,0,0,0,469.053,747.949Zm-14.4-14.684h6.695V736.9h-6.695Zm-.063,20.211h-6.695v-3.632h6.695Zm13.516,0h-6.695v-3.632h6.695Z",
    transform: "translate(-423 -328.37)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuOrgan);
export default __webpack_public_path__ + "static/media/MenuOrgan.fb25a7f83c72ef5268a19bbc242a3c55.svg";
export { ForwardRef as ReactComponent };